import * as React from 'react';
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";
import { DestinationMonthPicker } from "./month-picker";
import { Region } from '../../templates/fragments/region';
import { CountryBase } from '../../templates/fragments/country';

import { Breadcrumbs } from './breadcrumbs';
import { Resort } from '../../templates/fragments/resort';
export const DestinationPageHero = ({
    bgImage,
    month,
    header,
    resort = null,
    region = null,
    country = null,
    continent = null,
    doNotShowMonthPicker = false,
    className = ''
}: {
    bgImage: ImageDataLike,
    header: string,
    month?: string,
    resort?: Resort,
    region?: Region,
    country?: CountryBase
    continent?: string
    doNotShowMonthPicker?: boolean
    className?: string
}) => {

    return (<div className={`${className} w-full relative`}>

        <GatsbyImage alt="" image={getImage(bgImage)} className="h-[300px] md:h-[350px] xl:h-[420px]" />
        {/* Mask */}
        <div className="bg-black/30 w-full h-full absolute top-0"></div>

        <Breadcrumbs month={month} resort={resort} region={region} country={country} continent={continent}></Breadcrumbs>
        <h1 className="absolute top-[20px] bottom-[50px] w-full px-[24px] xm:px-12 md:px-40 text-center pointer-events-none grid items-center text-white leading-[1.3em] text-[30px] xm:text-[36px] sm:text-4xl font-b tracking-wide">{header}</h1>
        {!doNotShowMonthPicker && <DestinationMonthPicker omitLinks={resort && resort.isSingle} />}
    </div>)
}

